<template>
  <div class="wrapper">
    <div class="heading-left">
      <h2>{{ heading }}</h2>
      <p v-if="showCapacity" class="capacity">
        {{ currentItems }}/{{ maxItems }}
      </p>
    </div>
    <button
      :disabled="currentItems >= maxItems"
      :class="currentItems >= maxItems ? 'disabled' : ''"
      @click="$emit('button-click')"
      v-if="showButton"
    >
      <svg
        width="10"
        height="10"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5 5C11.625 5 11.75 5.0625 11.8438 5.15625C11.9375 5.25 12 5.375 12 5.5V6.5C12 6.65625 11.9375 6.78125 11.8438 6.875C11.75 6.96875 11.625 7 11.5 7H7V11.5C7 11.6562 6.9375 11.7812 6.84375 11.875C6.75 11.9688 6.625 12 6.5 12H5.5C5.34375 12 5.21875 11.9688 5.125 11.875C5.03125 11.7812 5 11.6562 5 11.5V7H0.5C0.34375 7 0.21875 6.96875 0.125 6.875C0.03125 6.78125 0 6.65625 0 6.5V5.5C0 5.375 0.03125 5.25 0.125 5.15625C0.21875 5.0625 0.34375 5 0.5 5H5V0.5C5 0.375 5.03125 0.25 5.125 0.15625C5.21875 0.0625 5.34375 0 5.5 0H6.5C6.625 0 6.75 0.0625 6.84375 0.15625C6.9375 0.25 7 0.375 7 0.5V5H11.5Z"
          fill="#4D48E8"
        />
      </svg>
      {{ buttonText }}
    </button>
    <button @click="$emit('cancel-click')" v-if="showCancelButton">
      {{ cancelButtonText }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'CardHeading',
  props: {
    heading: {
      type: String,
      default: '',
    },
    showCapacity: {
      type: Boolean,
      default: true,
    },
    currentItems: {
      type: Number,
      default: 0,
    },
    maxItems: {
      type: Number,
      default: 6,
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    showCancelButton: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: 'Add Item',
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel',
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
h2 {
  color: #202223;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
}

.capacity {
  padding-top: 1px;
  margin-left: 1rem;
  font-weight: 600;
  font-size: 14px;
  color: #727a88;
}

.heading-left {
  display: flex;
  align-items: center;
}

button {
  display: flex;
  font-size: 14px;
  line-height: 20px;
  color: #2c6ecb;
  font-weight: 400;

  &:focus {
    outline: none;
  }

  svg {
    margin: 4px 8px 0 0;
  }
}

.disabled {
  color: #cac9ff;
}
</style>
